'use strict'

export default function($stateProvider, $urlRouterProvider) {
  'ngInject'

  $urlRouterProvider.when('/devices', '/devices/list')
  $stateProvider
    .state('devices', {
      url: '/devices',
      template: require('./devices.html'),
      authenticate: true
    })
    .state('devices.confirm', {
      url: '/confirm?code',
      template: require('./confirm/confirm.html'),
      controller: 'DevicesConfirmController',
      controllerAs: 'DConfirmCtrl'
    })
    .state('devices.list', {
      url: '/list?page',
      template: require('./list/list.html'),
      controller: 'DevicesListController',
      controllerAs: 'DListCtrl'
    })
    .state('devices.import', {
      url: '/import',
      template: require('./import/import.html'),
      controller: 'DevicesImportController',
      controllerAs: 'DImportCtrl',
      authenticate: true
    })
    .state('devices.history', {
      url: '/history?page',
      template: require('./history/history.html'),
      controller: 'DevicesHistoryController',
      controllerAs: 'DHistoryCtrl',
      authenticate: true
    })
}



// WEBPACK FOOTER //
// ./client/app/devices/devices.routes.js